import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Checkbox,
  useMediaQuery,
  MenuItem
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import { Formik } from "formik";
import * as Yup from "yup";

import Header from "../../components/Header";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";

import { PostDatosPlus } from "../../services/metas.services";
import { getDatosUserAct } from "../../services/user.services";


const RegistroPlus = () => {
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const [funcionarios, setFuncionarios] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const [inputError, setInputError] = useState(false);
  const [montoConfirmado, setMontoConfirmado] = useState(false);
  const [erroresConfirmar, setErroresConfirmar] = useState({
        monto: false,
        motivo: false,
    });

  // 🔹 Traer funcionarios desde API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getDatosUserAct(); // tu endpoint real
        console.log("🚀 ~ fetchData ~ data:", data)
        const conCheck = data.map(f => ({
          ...f,
          checked: false,
          monto: null
        }));
        setFuncionarios(conCheck);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

        const confirmarMonto = (values) => {
          const errores = {
                monto: values.monto === "" || values.monto === null,
                motivo: !values.motivo || values.motivo.trim() === "",
            };
      
            setErroresConfirmar(errores);
      
            if (errores.monto || errores.motivo) {
                setMontoConfirmado(false);
                return;
            }
      
            setMontoConfirmado(true);

            if (Number(values.monto) === 0) {
              setFuncionarios(prev =>
                prev.map(f => {
                  // ⛔ si ya tiene monto asignado, no tocar
                  if (f.monto !== null && f.monto !== undefined) {
                    return f;
                  }
              
                  // ✅ solo los que NO tienen monto
                  return {
                    ...f,
                    checked: true,
                    monto: 0,
                    motivo: values.motivo,
                  };
                })
              );
            }
          // NO asignamos aún, solo habilitamos el flujo
        };



  // 🔹 Envío final
  const handleSubmitFinal = async (values) => {
    const seleccionados = funcionarios.filter(f => f.checked);

    console.log(
  "DEBUG seleccionados:",
  seleccionados.map(f => ({
    id: f.id_empleado,
    checked: f.checked,
    monto: f.monto,
    tipoMonto: typeof f.monto,
    isNaN: Number.isNaN(f.monto),
  }))
);

    // Validar seleccionados
    const sinMontoSeleccionados = seleccionados.filter(
        f => f.monto === null || f.monto === undefined
    );

    if (sinMontoSeleccionados.length > 0) {
        setRegistrationError(true);
        setError("Todos los funcionarios seleccionados deben tener monto");
        return;
    }

    // Validar todos
    const sinMontoTodos = funcionarios.filter(
        f => f.monto === null || f.monto === undefined
    );
    if (sinMontoTodos.length > 0) {
        setRegistrationError(true);
        setError("Debes asignar monto a todos los funcionarios antes de registrar");
        return;
    }


    setIsLoading(true);
    try {
      const payload = {
        month: values.month,
        year: values.year,
        motivo: values.motivo,
        registros: funcionarios.map(f => ({
          id_usuario: f.id,
          monto: f.monto,
          motivo: f.motivo ?? values.motivo,
        })),
      };
      console.log("🚀 ~ handleSubmitFinal ~ payload:", payload)

      await PostDatosPlus(payload);

      setRegistrationSuccess(true);
      setFuncionarios([]); // limpiar
    } catch (err) {
      setRegistrationError(true);
      setError(err.message || "Error al registrar");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box m="20px" sx={{height: "calc(100vh - 40px)", overflowY: "auto"}}>
      <Header title="Registrar Plus" subtitle="Registros de plus de salario" />

      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={() => setRegistrationSuccess(false)} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={() => setRegistrationError(false)}
          error={error}
        />
      )}

      {/* FORM */}
      <Formik
        initialValues={{
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            monto: "",
            motivo: "",

        }}
        validationSchema={checkoutSchema}
        onSubmit={handleSubmitFinal}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="20px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{ "& > div": { gridColumn: isNonMobile ? undefined : "span 4" } }}
            >
                <TextField
                    select
                    label="Mes"
                    name="month"
                    value={values.month}
                    onChange={handleChange}
                    error={!!touched.month && !!errors.month}
                    helperText={touched.month && errors.month}
                    sx={{ gridColumn: "span 2" }}
                >
                    {[
                        { value: 1, label: "Enero" },
                        { value: 2, label: "Febrero" },
                        { value: 3, label: "Marzo" },
                        { value: 4, label: "Abril" },
                        { value: 5, label: "Mayo" },
                        { value: 6, label: "Junio" },
                        { value: 7, label: "Julio" },
                        { value: 8, label: "Agosto" },
                        { value: 9, label: "Septiembre" },
                        { value: 10, label: "Octubre" },
                        { value: 11, label: "Noviembre" },
                        { value: 12, label: "Diciembre" },
                    ].map((m) => (
                        <MenuItem key={m.value} value={m.value}>
                            {m.label}
                        </MenuItem>
                    ))}
                </TextField>
    
                <TextField
                    select
                    label="Año"
                    name="year"
                    value={values.year}
                    onChange={handleChange}
                    error={!!touched.year && !!errors.year}
                    helperText={touched.year && errors.year}
                    sx={{ gridColumn: "span 2" }}
                >
                    {[2024, 2025, 2026, 2027, 2028, 2029, 2030].map((year) => (
                        <MenuItem key={year} value={year}>
                            {year}
                        </MenuItem>
                ))}
                </TextField>
    
            </Box>

            {/* MONTO + CONFIRMAR */}
            <Box mt={3} display="flex" gap={2}>
              <TextField
                label="Monto Plus"
                type="number"
                name="monto"
                onChange={(e) => {
                    handleChange(e);
                    setMontoConfirmado(false);
                  }}
                error={!!touched.monto && !!errors.monto}
                helperText={erroresConfirmar.monto && "Digite el monto plus"}
              />
              <TextField
                label="Motivo del Plus"
                name="motivo"
                onChange={(e) => {
                    handleChange(e);
                    setMontoConfirmado(false);
                }}
                error={!!touched.motivo && !!errors.motivo}
                helperText={erroresConfirmar.motivo && "Digite el motivo del plus"}
                sx={{ minWidth: 250 }}
              />
              <Button
                variant="contained"
                color="secondary"
                onClick={() => confirmarMonto(values)}
              >
                Confirmar Monto
              </Button>
            </Box>

            {/* TABLA FUNCIONARIOS */}
            <Box mt={4}>
              <Header title="Funcionarios" />

              <DataGrid
                autoHeight
                rows={funcionarios.map(f => ({ id: f.id_empleado, ...f }))}
                columns={[
                  {
                    field: "checked",
                    headerName: "✔",
                    renderCell: (params) => (
                            <Checkbox
                              checked={params.row.checked}
                              disabled={!montoConfirmado}
                              onChange={(e) => {
                                setFuncionarios(prev =>
                                  prev.map(f =>
                                    f.id_empleado === params.row.id_empleado
                                      ? {
                                            ...f,
                                            checked: e.target.checked,
                                            monto: e.target.checked ? Number(values.monto) : null,
                                            motivo: e.target.checked ? values.motivo : null,
                                        }
                                    : f
                                  )
                                );
                              }}
                              sx={{
                                color: "rgb(206, 220, 0)",
                                "&.Mui-checked": { color: "rgb(206, 220, 0)" },
                              }}
                            />

                        

                    ),
                  },
                  { field: "firstname", headerName: "Nombre", flex: 1 },
                  { field: "lastname", headerName: "Apellido", flex: 1 },
                  { field: "grupo", headerName: "Grupo", flex: 1 },
                  { field: "monto", headerName: "Monto Asignado", flex: 1 },
                ]}
                sortModel={[
                  { field: "id_grupo", sort: "asc" }
                ]}
              />
            </Box>

            {/* ENVIAR */}
                <Box
                  bottom={0}
                  bgcolor="background.default"
                  pt={4}
                  pr={3}
                  display="flex"
                  justifyContent="end"
                  pb={12}
                  sx={{ minWidth: "150px" }}
                >
                    <Button type="submit" variant="contained" color="secondary" sx={{ 
                        fontSize: "1.1rem",    // Texto más grande
                        padding: "12px 40px",  // Más espacio interno (arriba/abajo y lados)
                        fontWeight: "bold",    // Texto en negrita
                        minWidth: "200px",     // Ancho mínimo garantizado
                        borderRadius: "8px",
                        backgroundColor: "rgb(206 220 0)",    // Bordes un poco más redondeados (opcional)
                    }}
                  >
                    Registrar
                  </Button>
                </Box>
          </form>
        )}
      </Formik>
      
    </Box>
  );
};
const checkoutSchema = Yup.object().shape({
    month: Yup.number().required("Requerido"),
    year: Yup.number().required("Requerido"),
});


export default RegistroPlus;